export function makeBrandThumbnail(brand: { code: string }) {
  return {
    aspectRatio: 1,
    src: `/${brand.code}-maskable.jpg`,
    sizes: '100vw',
    srcSet: `/${brand.code}-maskable.jpg`,
  };
}
